const API_BASE_URL = process.env.REACT_APP_API_BASE_URL_PROD;

export const apiService = {
  // Adicionar usuário à waitlist
  async addToWaitlist(data) {
    try {
      console.log('🔐 API enviando token:', data.turnstileToken);
      const response = await fetch(`${API_BASE_URL}/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: data.name,
          email: data.email,
          cityId: data.cityId,
          referredByCode: data.referralCode || null,
          turnstileToken: data.turnstileToken
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Erro ao adicionar à waitlist');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  // Buscar indicações de um usuário por email
  async getReferralsByEmail(email) {
    try {
      const response = await fetch(`${API_BASE_URL}/waitlist/referrals?email=${encodeURIComponent(email)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Erro ao buscar indicações');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  // Buscar cidades disponíveis
  async getCities() {
    try {
      const response = await fetch(`${API_BASE_URL}/places/cities`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar cidades');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  // Enviar email de verificação
  async sendVerificationEmail(email) {
    try {
      const response = await fetch(`${API_BASE_URL}/waitlist/send-verification`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Erro ao enviar email de verificação');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  // Verificar email
  async verifyEmail(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/waitlist/verify-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Erro ao verificar email');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  // Buscar usuário da waitlist por email
  async getUserByEmail(email) {
    try {
      const response = await fetch(`${API_BASE_URL}/waitlist/user?email=${encodeURIComponent(email)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        if (response.status === 404) {
          return null; // Usuário não encontrado
        }
        const errorData = await response.json();
        throw new Error(errorData.error || 'Erro ao buscar usuário');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  // Buscar estabelecimento por ID (endpoint público)
  async getPlaceById(placeId) {
    try {
      const response = await fetch(`${API_BASE_URL}/places/public/${placeId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        if (response.status === 404) {
          throw new Error('Estabelecimento não encontrado');
        }
        const errorData = await response.json();
        throw new Error(errorData.error || 'Erro ao buscar estabelecimento');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  }
}; 